export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-heart-a29329ee2252a48c27e5abb3a46495f3.svg";